export enum TaskListOrder {
  None = "None",
  RoomNumber = "Room",
  TaskTypeName = "TaskTypeName",
  AssignedTo = "AssignedTo",
  Supervisor = "Supervisor",
  TaskDate = "TaskDate"
}